import EditBirthDate from '@features/AlcoholOptIn/EditBirthDate';
import { useAlcoholEligibilityContext } from '@context/AlcoholEligibilityContext';
import useLocalizedRoutes from '@hooks/i18n/useLocalizedRoutes';
import Modal from '@monofront/design-system/organisms/Modal';
import { RoutesEnum } from '@monofront/types';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

const ModalAgeVerification = () => {
  const {
    updateUserBirthDate,
    alcoholEligibilityState,
    dispatchAlcoholEligibility,
    isUserEligibleToBuyAlcohol,
  } = useAlcoholEligibilityContext();
  const { getPath } = useLocalizedRoutes();

  const tProduct = useTranslations('Products');

  const confirmAgeUpdate = async (dateOfBirth: string) => {
    const updateResponse = await updateUserBirthDate(dateOfBirth);

    if (!updateResponse) {
      return;
    }

    dispatchAlcoholEligibility({
      type: 'setBirthDate',
      birthDate: dateOfBirth,
    });
  };

  useEffect(() => {
    if (alcoholEligibilityState.birthDate) {
      const isEligible = isUserEligibleToBuyAlcohol();

      if (isEligible) {
        dispatchAlcoholEligibility({ type: 'canBuyProduct' });
        alcoholEligibilityState.incrementProductCount();
        toast(tProduct('AlcoholEligibilityModal.eligibleMessage'));
      } else {
        dispatchAlcoholEligibility({ type: 'triggerIneligibilityToast' });
      }
    }
  }, [alcoholEligibilityState.birthDate]);

  return (
    <Modal
      isClosable={false}
      UNSAFE_className="sm:tw-max-w-[450px] tw-max-w-[343px] !tw-px-6 sm:!tw-px-10 !tw-py-10"
      centered
      isOpen={alcoholEligibilityState.isAgeVerificationModalOpen}
      hasPadding
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-text-center">
        <h2 className="tw-lf-title-sm tw-mb-4">
          {tProduct('AlcoholEligibilityModal.title')}
        </h2>
        <p className="tw-mb-6">
          {tProduct('AlcoholEligibilityModal.confirmationMessage')}
        </p>
        <EditBirthDate
          onFormCompleted={() =>
            dispatchAlcoholEligibility({
              type: 'closeAgeVerificationModal',
            })
          }
          confirmAgeUpdate={confirmAgeUpdate}
        />
        <p className="tw-mt-8 tw-text-xs">
          {tProduct.rich('AlcoholEligibilityModal.legalInfo', {
            link: (children) => (
              <Link
                target="_blank"
                className="tw-lf-link-sm tw-text-xs tw-text-black-1000"
                href={getPath(RoutesEnum.PRIVACY_POLICIES)}
              >
                {children}
              </Link>
            ),
          })}
        </p>
      </div>
    </Modal>
  );
};

export default ModalAgeVerification;
